(function () {
  // Last-line-of-defense fix for "picked Medium, got Small in the cart".
  // Dawn resolves the variant id via an async fetch keyed on the
  // selected option VALUE IDs, which depends on several DOM/timing
  // pieces (selected attribute bookkeeping, section re-render,
  // updateVariantInputs) all landing correctly before submit. Rather
  // than keep chasing which of those pieces is flaky, this reads the
  // full variant list embedded on the page and, on every option
  // change and again right before submit, synchronously computes the
  // correct variant id from the option VALUE STRINGS currently
  // selected in the DOM and force-writes it onto the add-to-cart
  // form's hidden id input. It doesn't depend on network timing, so
  // it can't land a stale/incorrect id.

  function getVariants(container) {
    var script = container.querySelector('[data-full-variant-list]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptionStrings(container) {
    var values = [];
    container
      .querySelectorAll('.product-form__input--dropdown select, fieldset input:checked')
      .forEach(function (element) {
        if (element.tagName === 'SELECT') {
          if (element.value !== '') values.push(element.value);
        } else {
          values.push(element.value);
        }
      });
    return values;
  }

  function findMatchingVariant(variants, selected) {
    if (!variants || !selected.length) return null;
    return (
      variants.find(function (variant) {
        return (
          variant.options.length === selected.length &&
          variant.options.every(function (value, index) {
            return value === selected[index];
          })
        );
      }) || null
    );
  }

  function correct(container) {
    var variants = getVariants(container);
    var selected = getSelectedOptionStrings(container);
    var matched = findMatchingVariant(variants, selected);
    if (!matched) return;

    var form = document.getElementById('product-form-' + container.dataset.section);
    if (!form) return;

    var input = form.querySelector('input[name="id"]');
    if (input && String(input.value) !== String(matched.id)) {
      input.value = matched.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function bind(container) {
    if (container.dataset.correctionBound) return;
    container.dataset.correctionBound = 'true';
    container.addEventListener('change', function () {
      correct(container);
    });
    correct(container);
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(bind);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var container = document.querySelector(
        'variant-selects[data-section="' + form.id.replace('product-form-', '') + '"]'
      );
      if (container) correct(container);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:refresh', init);
})();
